<template>
  <div
    :class="['frag-field', dirty && !isValid ? 'invalid' : '']"
    ref="fragField"
  >
    <input
      v-for="(frag, i) in frags"
      :key="frag.id"
      type="text"
      v-model="fragments[i]"
      :maxlength="frag.length"
      :placeholder="frag.placeholder"
      @input="autoTab($event, i, `f-field-${i + 1}`)"
      :ref="`f-field-${i}`"
      v-mask="frag.mask"
      :style="`flex: ${Math.min(3, frag.length)}`"
      v-tooltip.top-center="{
        content: frag.validation ? frag.validationMsg : null
      }"
    />
    <transition name="fade-slide" appear>
      <label v-if="errMsg" class="err-msg">
        <i class="fas fa-exclamation-circle mr-xs"></i>
        <span v-text="errMsg"></span>
      </label>
    </transition>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  props: {
    frags: {
      type: Array,
      required: true
    },
    req: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    errMsg: String,
    value: String
  },
  data() {
    return {
      fragments: []
    };
  },
  watch: {
    fragments() {
      // console.log("frags >", this.fragments, _.compact(this.fragments).length);

      if (this.readyToValidate) {
        this.$emit("input", this.fragments.join(""));
        // let isValid = !_.reject(
        //   _.map(this.fragments, (f, i) => f.length === this.frags[i].length)
        // ).length;
        // console.log("isvalid > ", isValid);
        this.$emit("validate-field", "patientId", this.isValid);
      }
    }
  },
  mounted() {
    if (this.value) {
      console.log("IN UPDATE MODE.... >> ", this.value);
      let structure = this.frags.map(f => f.length);
      let split = this.value.split("");

      let frags = structure.map((length, i) => {
        let from = _.sum(_.take(structure, i));
        return split.slice(from, from + length).join("");
      });
      // console.log("frafgs>>> ", frags);
      // this.$set(this, "fragments", frags);
      this.fragments = frags;
    } else {
      this.fragments = Array(this.frags.length);
      // this.$set(this, "fragments", );
    }
    console.log("isvalid>", this.isValid);
    this.$emit("validate-field", "patientId", this.isValid);

    // this.$set(this, "fragments", frags);
  },
  methods: {
    autoTab: _.debounce(function(e, index, next) {
      let frag = this.frags[index];
      // console.log(e.target.value);
      let val = e.target.value;
      let _maxlength = e.target.getAttribute("maxlength");
      let _length = val.length;
      let el = this.$refs[next]
        ? this.$refs[next].length
          ? this.$refs[next][0]
          : this.$refs[next]
        : null;

      // console.log("autoTb > ", _maxlength, " :: ", _length);
      console.log("frag.validation: ", frag.validation);

      if (!_length) {
        var enter_valid_char = this.localize('enter_valid_char');
        this.$toasted.show(enter_valid_char, {
          position: "bottom-center",
          // iconPack: "fontawesome",
          type: "warning",
          theme: "bubble",
          icon: {
            name: "fal fa-exclamation-circle mr-xs"
          }
        });
      } else if (_length >= _maxlength) {
        let valid = true;
        if (frag.validation) {
          console.log("val: ", JSON.stringify(val));
          valid = frag.validation.test(val.toString());
          console.log("valid: ", valid);
          if (!valid) {
            this.$toasted.show("Please enter the correct format", {
              position: "bottom-center",
              // iconPack: "fontawesome",
              type: "warning",
              theme: "bubble",
              icon: {
                name: "fal fa-exclamation-circle mr-xs"
              }
            });
            return false;
          }
        }
        if (valid && index < this.frags.length - 1 && el) {
          el.focus();
        }
      }
      // else if (_length >= _maxlength && index < this.frags.length - 1 && el) {
      //   el.focus();
      // }
    }, 100)
  },
  computed: {
    readyToValidate() {
      return _.compact(this.fragments).length === this.fragments.length;
    },
    isValid() {
      let vm = this;
      if (this.readyToValidate) {
        return !_.reject(
          _.map(this.fragments, (f, i) => {
            // Check for custom validation (regex)
            let pass = true;
            if (vm.frags[i].validation) {
              pass = vm.frags[i].validation.test(f);
            }

            // if (!pass) {
            //   this.$toasted.show("Please enter valid character", {
            //     position: "bottom-center",
            //     // iconPack: "fontawesome",
            //     type: "warning",
            //     theme: "bubble",
            //     icon: {
            //       name: "fal fa-exclamation-circle mr-xs"
            //     }
            //   });
            // }
            return pass && f.length === this.frags[i].length;
          })
        ).length;
      }

      return false;
    }
  }
};
</script>

<style lang="stylus" scoped>
.frag-field
  direction ltr
  border-radius 20px
  padding 0 10px
  width 230px
  border 1px solid gray_4
  height 44px
  flex none !important
  _flex(row, nowrap, center, space-evenly)
  transition border 0.3s ease-out
  &.invalid
    border 1px solid red_4
  input
    min-width 0
    // ^^ Firefox bug fix ^^
    padding 0 5px
    border none
    height 18px
    border-right 1px solid gray_3
    text-align center
    appearance none
    // &:first-child
    //   padding-right 10px
    &:focus
      border-left none
      border-top none
      border-bottom none
      border-right 1px solid gray_4
      border-left-color gray_4 !important
    &:last-child
      border-right none
</style>
